@switch (systemConfigService.config.payment.system) {
    @case ('gocardless') {
        <setup-gocardless-order-payment-plan></setup-gocardless-order-payment-plan>
    }
    @case ('manual') {
        <setup-manual-order-payment-plan></setup-manual-order-payment-plan>
    }
    @default {
        <account-page title="Something went wrong">
            <p>{{ systemConfigService.config.payment.system }} service has not been configured</p>
        </account-page>
    }
}
